export function filterByGroup<T>(
  data: T[],
  filterBy: string,
  expectedFilter: string,
  itemIDs: string[],
  getIDs: (item: T) => string[] | undefined
): T[] {
  if (filterBy !== expectedFilter) return data;

  return data.filter((item) => {
    const ids = getIDs(item);
    return ids?.some((id) => itemIDs.includes(id));
  });
}
